<template lang="">
<div class="wrap-kiosk funeral type4">
    <div class="wrap--inner">
        <div class="name--wrap">
            <span class="go"><img src="../../assets/kiosk/images/g_type_4.png" alt ="고" /></span>
            <div>{{ funeralInfo.deceasedName }}</div>
            <span>님</span>
        </div>
        <div class="comment--wrap">
            <div class="swiper commentSwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="payment in paymentList">
                    <div v-html="payment.message"></div>
                    <p>{{ payment.sender }}</p>
                </div>
                </div>
            </div>
        </div>
        <div class="guest--wrap">
            <div class="guest__title"><img src="../../assets/kiosk/images/guest_title_4.png" alt ="진심을 전하신 분" /></div>
            <ul>
                <li v-for="payment in paymentList">{{ payment.name }}</li>
            </ul>
        </div>
        <div class="qr--wrap">
            <canvas ref="qrcanvas"></canvas>
        </div>
    </div>
</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import QRCode from 'qrcode';
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import '@/assets/kiosk/css/common.css';

const paymentModule = 'paymentModule'

export default {
    props: {
        funeralInfo: {
            type: Object,
            required: true
        },
        invitationSeq: {
            type: Number,
            required: true
        }
    },

    data () {
        return {
            page: this.$route.query.page,
            currentIndex: 0,
            updateInterval: null,
            qrUrl: '',
            commentSwiper: null
        }
    },

    methods: {
        ...mapActions(paymentModule, ["requestPaymentListForKiosk"]),

        async fetchData() {
            try {
                const { invitationSeq, page } = this;
                await this.requestPaymentListForKiosk({ invitationSeq, page });
            } catch (error) {
                console.error("데이터 갱신 오류:", error);
            }
        },

        async generateQRCode() {
            try {
                const currentUrl = window.location.href
                let newUrl = currentUrl.replace('/kiosk/', '/').split('?')[0]

                const canvas = this.$refs.qrcanvas
                if (canvas) {
                    await QRCode.toCanvas(canvas, newUrl, {
                        width: canvas.offsetWidth,
                        margin: 0
                    });

                    // canvas.style.width = '';
                    // canvas.style.height = '';
                }
            } catch (err) {
                console.error('QR 생성 실패:', err)
            }
        },

        initSwiper() {
            if (this.commentSwiper) {
                this.commentSwiper.destroy(true, true);
                this.commentSwiper = null;
            }

            // if (this.paymentList && this.paymentList.length > 0) {
                this.commentSwiper = new Swiper('.commentSwiper', {
                    modules: [Autoplay, EffectFade],
                    observer: true,
                    observeParents: true,
                    loop: true,
                    spaceBetween: 0,
                    effect: 'fade',
                    speed: 800,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false,
                    },
                });
            // }
        }
    },

    computed: {
        ...mapState(paymentModule, ['paymentList'])
    },

    async mounted () {
        await this.fetchData();
        this.dataRefreshInterval = setInterval(this.fetchData, 10000);
        this.generateQRCode();

        this.$nextTick(() => {
            this.initSwiper();
        });
    },

    beforeUnmount() {
        if (this.updateInterval) clearInterval(this.updateInterval);
        if (this.dataRefreshInterval) clearInterval(this.dataRefreshInterval);
        if (this.commentSwiper) this.commentSwiper.destroy(true, true);
    },

    watch: {
        paymentList() {
            this.$nextTick(() => {
                // this.initSwiper();
                if (this.commentSwiper) {
                    this.commentSwiper.update();
                }
            });
        }
    }
}
</script>
<style lang="">

</style>